import { IonCol, IonContent, IonGrid, IonIcon, IonLabel, IonRippleEffect, IonRow, IonSkeletonText, useIonRouter } from "@ionic/react";
import { useQuery } from "@tanstack/react-query";
import { t } from "i18next";
import { chevronForward } from "ionicons/icons";
import React from "react";
import { PageHeader } from "../../components/PageHeader";
import BasicTemplate from "../../components/PageTemplates/BasicTemplate";
import { ApiService } from "../../services";

const ContactCategories = (props: any) => {
  const router = useIonRouter();
  const { data, isLoading } = useQuery({
    queryKey: ["helpdesk-categories"],
    queryFn: () => {
      return ApiService.get("helpdesk-categories");
    },
  });

  const navigate = (helpdeskCategory: any) => {
    router.push(`/contact/${helpdeskCategory.id}`);
  };

  return (
    <BasicTemplate hideBackButton={false} hideHeader={false} title={t("helpdesk")}>
      <IonContent className={"ion-padding"}>
        <PageHeader>{t("helpdesk")}</PageHeader>

        <div className={"contact-categories-list"}>
          {isLoading &&
            [0, 1, 2, 3].map((i) => (
              <div key={`skeleton-text-${i}`} className={"ion-activatable ripple-parent rounded-rectangle"}>
                <IonSkeletonText
                  animated
                  style={{
                    width: "65%",
                    height: "24px",
                  }}
                />

                <IonSkeletonText
                  animated
                  style={{
                    width: "90%",
                  }}
                />

                <IonSkeletonText
                  animated
                  style={{
                    width: "60%",
                  }}
                />
              </div>
            ))}

          {!isLoading &&
            (data?.data?.length ? (
              <>
                <p>{t("contactUsText")}</p>
                {data?.data?.map((helpdeskCategory: any) => (
                  <>
                    <div
                      key={`helpdesk-category-${helpdeskCategory.id}`}
                      className={"ion-activatable ripple-parent rounded-rectangle"}
                      onClick={() => {
                        navigate(helpdeskCategory);
                      }}
                    >
                      <IonGrid
                        style={{
                          width: "100%",
                          padding: 0,
                        }}
                      >
                        <IonRow>
                          <IonCol size={"11"}>
                            <IonLabel
                              className={"block"}
                              style={{
                                fontWeight: "bold",
                              }}
                            >
                              {helpdeskCategory.name}
                            </IonLabel>
                            <IonLabel
                              className={"block ion-text-wrap"}
                              style={{
                                fontSize: "0.8em",
                              }}
                            >
                              {helpdeskCategory.description}
                            </IonLabel>
                          </IonCol>

                          <IonCol
                            size={"1"}
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >
                            <IonIcon icon={chevronForward} />
                          </IonCol>
                        </IonRow>
                      </IonGrid>
                      <IonRippleEffect></IonRippleEffect>
                    </div>
                  </>
                ))}
              </>
            ) : (
              <p>{t("noContactCategories")}</p>
            ))}
        </div>
      </IonContent>
    </BasicTemplate>
  );
};

export default ContactCategories;
